<template>
  <div class="amendments-container" v-if="!isLoading">
    <h1 style="margin-left: 20px;">
      Ausweise (abgelaufen)
    </h1>
    <div class="con mt-4" style="margin-left: 10px;">
      <vs-row class="mt-3">
        <vs-input
          class="search-input org-width"
          icon-after
          :placeholder="$t('dashboard.expire-card.table.name-search')"
          v-model="searchUser"
          icon="search"
        />
        <vs-input
          type="date"
          class="ml-3"
          icon="search"
          icon-after
          v-model="searchExpireDate"
        />
      </vs-row>
      <!-- Tabs -->
      <vs-row class="menu mb-4">
        <div
          class="item me-2 p-2"
          :class="{ active: activeTab === 'extendable' }"
          @click="activeTab = 'extendable'"
        >
          <span>Ausweise</span>
        </div>
        <div
          class="item me-2 p-2"
          v-if="hasDroneCards"
          :class="{ active: activeTab === 'drone' }"
          @click="activeTab = 'drone'"
        >
          <span>Fernpiloten</span>
        </div>
      </vs-row>

      <!-- Verlängerbare Ausweise -->
      <div v-if="activeTab === 'extendable'">
        <h6
          class="p-2"
          style="color:grey; font-size: 0.9rem; text-align: left;"
        >
          {{ $t("select-idCard-for-extend") }}
        </h6>
        <div class="idcard-con">
          <div class="con mt-4">
            <div class="outer-con2">
              <div
                class="table-container"
                style="overflow-y: auto; max-width: 100%;"
              >
                <table>
                  <thead>
                    <tr>
                      <th>
                        <input
                          style="margin-left: 5px;"
                          type="checkbox"
                          v-model="selectAll2"
                          @change="selectAllItems2"
                        />
                      </th>
                      <th @click="sort('valid_until')">
                        {{ $t("dashboard.expire-card.table.valid-until") }}
                        <div
                          class="arrow"
                          v-if="'valid_until' == currentSort"
                          :class="ascending ? 'arrow_up' : 'arrow_down'"
                        ></div>
                      </th>
                      <th @click="sort('organisation_name')">
                        {{ $t("dashboard.expire-card.table.organization") }}
                        <div
                          class="arrow"
                          v-if="'organisation_name' == currentSort"
                          :class="ascending ? 'arrow_up' : 'arrow_down'"
                        ></div>
                      </th>
                      <th @click="sort('person_last_name')">
                        {{ $t("Name") }}
                        <div
                          class="arrow"
                          v-if="'person_last_name' == currentSort"
                          :class="ascending ? 'arrow_up' : 'arrow_down'"
                        ></div>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="idCard in filteredIdCards"
                      :key="idCard.id"
                      @click="openIdCard(idCard)"
                    >
                      <td>
                        <input
                          type="checkbox"
                          :value="idCard.id"
                          v-model="selectedIdCards2"
                          @click.stop
                        />
                      </td>
                      <td>{{ idCard.valid_until | moment("DD.MM.YYYY") }}</td>
                      <td>{{ idCard.organisation_name }}</td>
                      <td>
                        {{ idCard.person_last_name }},
                        {{ idCard.person_first_name }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <vs-button
              :disabled="!selectedIdCards2 || selectedIdCards2.length === 0"
              @click="extendConfirm"
              class="organ-btn"
              icon="event"
              :style="{
                opacity:
                  !selectedIdCards2 || selectedIdCards2.length === 0 ? 0.5 : 1,
                pointerEvents:
                  !selectedIdCards2 || selectedIdCards2.length === 0
                    ? 'none'
                    : 'auto',
              }"
            >
              {{ $t("extend-idCard") }}
            </vs-button>

            <PopupExtendIdCard
              v-show="showPopupExtend"
              :visible="showPopupExtend"
              :idCards="selectedIdCardsDetails"
              @close="showPopupExtend = false"
              @extended="handleExtended"
            />
          </div>
        </div>
      </div>

      <!-- Drohnenausweise -->
      <div v-else-if="activeTab === 'drone'">
        <h6
          class="p-2"
          style="color:grey; font-size: 0.9rem; text-align: left;"
        >
          {{ $t("select-idCard-for-extend-drone") }}
        </h6>
        <div class="idcard-con">
          <div class="con mt-4">
            <div class="outer-con2">
              <div
                class="table-container"
                style="overflow-y: auto; max-width: 100%;"
              >
                <table>
                  <thead>
                    <tr>
                      <th @click="sort('valid_until')">
                        {{ $t("dashboard.expire-card.table.valid-until") }}
                        <div
                          class="arrow"
                          v-if="'valid_until' == currentSort"
                          :class="ascending ? 'arrow_up' : 'arrow_down'"
                        ></div>
                      </th>
                      <th @click="sort('organisation_name')">
                        {{ $t("dashboard.expire-card.table.organization") }}
                        <div
                          class="arrow"
                          v-if="'organisation_name' == currentSort"
                          :class="ascending ? 'arrow_up' : 'arrow_down'"
                        ></div>
                      </th>
                      <th @click="sort('person_last_name')">
                        {{ $t("Name") }}
                        <div
                          class="arrow"
                          v-if="'person_last_name' == currentSort"
                          :class="ascending ? 'arrow_up' : 'arrow_down'"
                        ></div>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="idCard in filteredIdCards_Layout1"
                      :key="idCard.id"
                      @click="openIdCard(idCard)"
                    >
                      <td>{{ idCard.valid_until | moment("DD.MM.YYYY") }}</td>
                      <td>{{ idCard.organisation_name }}</td>
                      <td>
                        {{ idCard.person_last_name }},
                        {{ idCard.person_first_name }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- DEBUG MODE -->
      <div v-if="isDebugMode">
        <h1>customerConfiguration</h1>
        {{ customerConfiguration }}
        <h1>idCards</h1>
        {{ idCards }}
        <h1>user</h1>
        {{ user }}
      </div>

      <PopupIDcard ref="popup" :organization="selectedOrganization" />
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import PopupIDcard from "@/components/id-card/PopupIDcard.vue";
import moment from "moment";
import _ from "lodash";
import PopupExtendIdCard from "../../components/id-card/PopupExtendIdCard.vue";

export default Vue.extend({
  name: "ExpiredIDCards",
  components: {
    PopupIDcard,
    PopupExtendIdCard,
  },

  async mounted() {
    await this.$store.dispatch("organization/loadOrganizations");
    await this.$store.dispatch("layout/loadLayouts");
    await this.$store.dispatch("idCard/loadIdCards", { status: "expired" });
    // await this.$store.dispatch('customer/loadCustomer', this.user.customer_id)
    await this.$store.dispatch(
      "customer/loadCustomerConfiguration",
      this.user.customer_id
    );
    this.isLoading = false;
    const droneCards = this.idCards.filter((card) => {
      const org = this.$store.getters["organization/getOrganizations"].find(
        (org) => org.id === card.organisation_id
      );
      if (!org) return false;

      const layout = this.$store.getters["layout/getLayouts"].find(
        (lay) => lay.id === org.id_card_layout_id
      );
      if (!layout) return false;

      const preconfId = Number(layout.preconfigured_layout_id);
      return preconfId === 1 || preconfId === 3;
    });

    this.hasDroneCards = droneCards.length > 0;
  },

  data() {
    return {
      selectedOrganization: {},
      searchExpireDate: "",
      searchUser: "",
      prop_user: [],
      ascending: true,
      currentSort: "valid_until",
      currentSortDir: "desc",
      selectedIdCards2: [],
      selectAll2: false,
      idCard: {},
      showPopupExtend: false,
      selectedIdCardsDetails: [],
      activeTab: "extendable",
      isLoading: true,
      hasDroneCards: false,
    };
  },
  computed: {
    idCards: function() {
      // return this.$store.getters['idCard/getIdCards']
      const idCards = this.$store.getters["idCard/getIdCards"];
      if (!idCards) return [];
      const expiredCards = idCards.filter((card) => card.status === "expired");
      idCards.sort((a, b) => {
        let modifier = 1;
        if (this.currentSortDir === "desc") modifier = -1;
        if (a[this.currentSort] < b[this.currentSort]) return -1 * modifier;
        if (a[this.currentSort] > b[this.currentSort]) return 1 * modifier;
        return 0;
      });
      return expiredCards;
    },
    filteredIdCards_Layout1: function() {
      const organisations =
        this.$store.getters["organization/getOrganizations"] || [];
      const layouts = this.$store.getters["layout/getLayouts"] || [];
      return this.idCards.filter((card) => {
        const org = organisations.find(
          (org) => org.id === card.organisation_id
        );
        if (!org) return false;

        const layout = layouts.find((lay) => lay.id === org.id_card_layout_id);
        if (!layout) return false;

        const preconfId = Number(layout.preconfigured_layout_id);
        if (preconfId !== 1 && preconfId !== 3) return false;

        // Suchfilter für Name
        if (this.searchUser) {
          const name = `${card.person_first_name} ${card.person_last_name}`.toLowerCase();
          if (!name.includes(this.searchUser.toLowerCase())) return false;
        }

        // Suchfilter für Ablaufdatum
        if (this.searchExpireDate) {
          if (!card.valid_until.includes(this.searchExpireDate)) return false;
        }

        return true;
      });
    },
    filteredIdCards: function() {
      const organisations =
        this.$store.getters["organization/getOrganizations"] || [];
      const layouts = this.$store.getters["layout/getLayouts"] || [];
      return this.idCards.filter((card) => {
        const org = organisations.find(
          (org) => org.id === card.organisation_id
        );
        if (!org) return false;

        const layout = layouts.find((lay) => lay.id === org.id_card_layout_id);
        if (!layout) return false;

        const preconfId = Number(layout.preconfigured_layout_id);
        if (preconfId === 1 || preconfId === 3) return false;

        // Suchfilter für Name
        if (this.searchUser) {
          const name = `${card.person_first_name} ${card.person_last_name}`.toLowerCase();
          if (!name.includes(this.searchUser.toLowerCase())) return false;
        }

        // Suchfilter für Ablaufdatum
        if (this.searchExpireDate) {
          if (!card.valid_until.includes(this.searchExpireDate)) return false;
        }

        return true;
      });
    },

    user() {
      return this.$store.getters["auth/getUser"];
    },

    customer() {
      return this.$store.getters["customer/getCustomer"];
    },
    customerConfiguration() {
      return this.$store.getters["customer/getCustomerConfiguration"];
    },
    // getExpiredIdCards(){
    //   // const expiry_warning_days = 909 //30 // 909
    //   const expiry_warning_days = this.customerConfiguration.expiry_warning_days
    //   const idCards = this.$store.getters['idCard/getIdCards']
    //   const expiredIdCards = idCards.filter(card => {
    //     const valid_until = Math.floor(Date.parse(card.valid_until) / 1000)
    //     const now = Math.floor((new Date()).getTime() / 1000)

    //     // Delta in days
    //     const delta = (expiry_warning_days * (3600*24))
    //     if (valid_until < now+delta) {
    //       return true
    //     }
    //     return false
    //   });

    //   if (this.searchUser !== "") {
    //     return expiredIdCards.filter(card => {
    //       const name = (card.person_first_name + card.person_last_name).toLowerCase()
    //       if (name.toLowerCase().includes(this.searchUser)) {
    //         return true;
    //       }
    //       return false
    //     });

    //   } else if (this.searchExpireDate !== "") {
    //     return expiredIdCards.filter(card => {
    //       if (card.valid_until.toLowerCase().includes(this.searchExpireDate)) {
    //         return true;
    //       }
    //       return false
    //     });

    //   } else {
    //     return expiredIdCards
    //   }
    // }
  },
  methods: {
    sort: function(s) {
      if (s === this.currentSort) {
        this.currentSortDir = this.currentSortDir === "asc" ? "desc" : "asc";
        this.ascending = !this.ascending;
      }
      this.currentSort = s;
    },
    async openIdCard(idCard) {
      // await this.$store.dispatch('person/loadPerson', idCard.person_id)
      // const person =  this.$store.getters['person/getPerson']
      // await this.$store.dispatch('organization/loadOrganization', person.organisation_id)

      // this.selectedOrganization = this.$store.getters['organization/getOrganization']

      const popup = this.$refs.popup;
      popup.openEdit(idCard);
    },
    selectAllItems2() {
      if (this.selectAll2) {
        this.selectedIdCards2 = this.filteredIdCards.map((idCard) => idCard.id);
      } else {
        this.selectedIdCards2 = [];
      }
    },
    handleExtended() {
      this.showPopupExtend = false;
      this.selectedIdCards2 = []; // ggf. Auswahl zurücksetzen
      this.$store.dispatch("idCard/loadIdCards"); // Daten neu laden
    },

    toggleSelectItem(id) {
      const index = this.selectedIdCards2.indexOf(id);
      if (index > -1) {
        this.selectedIdCards2.splice(index, 1);
      } else {
        this.selectedIdCards2.push(id);
      }
    },
    extendConfirm() {
      this.selectedIdCardsDetails = this.idCards.filter((card) =>
        this.selectedIdCards2.includes(card.id)
      );
      this.showPopupExtend = true;
    },
  },

  watch: {
    selectedIdCards2(newVal) {
      this.selectAll2 = newVal.length === this.idCards.length;
    },

    idCards(newCards) {
      this.selectAll2 =
        newCards.length > 0 &&
        newCards.every((card) => this.selectedIdCards2.includes(card.id));
    },
  },
});
</script>

<style scoped>
.vuesax-app-is-ltr .vs-input--input.icon-after-input {
  padding-right: 2.5rem !important;
}
.item {
  width: 150px;
  height: 40px;
  border-radius: 4px;

  font-family: "Open Sans", sans-serif;
  color: #005b9b;
  border: 1px solid #ddd;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  cursor: pointer;
}
.active {
  background-color: #dfe6f7;
}
</style>
